import React, { useEffect } from "react"
import { useDispatch, useSelector } from "react-redux"
import { Col, Modal, ModalBody, ModalFooter, Row } from "reactstrap"
import { putExpenseCatReport as editExpenseCategory } from "store/actions"

const ConfirmationModal = props => {
  const {
    modal,
    toggle,
    handleCancel,
    expenseId,
    newValue,
  } = props

  const dispatch = useDispatch()

  const handleConfirm = () => {
    console.log(newValue, expenseId)
    dispatch(editExpenseCategory({ expenseId, expenseCatId: newValue}))
    toggle()
  }

  const reports = useSelector(state => state.Reports)
  const { putExpenseCatReport: putExpenseCatReport, loadingPutExpenseCatReport: loading, PutExpenseCatReportErr: err } =
    reports

    useEffect(() => {
      console.log(putExpenseCatReport)
    }, [putExpenseCatReport])


  return (
    <Modal
      isOpen={modal}
      toggle={toggle}
      backdrop={"static"}
      id="staticBackdrop"
    >
      <ModalBody>
        <Row>
          <Col lg="12" className="text-center">
            <Row>
              <i
                className="mdi mdi-alert-circle-outline"
                style={{ fontSize: "9em", color: "orange" }}
              />
            </Row>
            <Row>
              <h5>Are you sure you want to expense category?</h5>
            </Row>
          </Col>
        </Row>
      </ModalBody>
      <ModalFooter>
        <div>
          <button
            type="button"
            className="btn btn-primary"
            onClick={handleConfirm}
            disabled={loading}
          >
            {loading && (
              <i className="bx bx-loader bx-spin font-size-16 align-middle me-2"></i>
            )}
            Yes
          </button>
          <button
            type="button"
            className="btn btn-light"
            onClick={handleCancel}
          >
            Cancel
          </button>
        </div>
      </ModalFooter>
    </Modal>
  )
}

export default ConfirmationModal
